import { Box, Typography, makeStyles } from '@material-ui/core'
import React from 'react'
import PropTypes from 'proptypes'
import styled from 'styled-components'
import { placeImage } from '../../utils'
import Svg from 'react-inlinesvg'
import AppleIcon from '../../images/icons/apple.svg'

const BoxWrap = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  position: 'relative',
  flex: '0 0 275px',
  padding: theme.spacing(4, 2),
  backgroundColor: theme.colors.grey1,
  maxWidth: 275,
  margin: '12px 24px',
  cursor: 'pointer',
  '&::after': {
    position: 'absolute',
    content: '""',
    top: -10,
    left: -10,
    width: 'calc(100% + 20px)',
    height: 'calc(100% + 20px)',
    zIndex: '-1',
    borderRadius: 8,
    backgroundImage: 'linear-gradient(143deg, #16bce6, #299dc1)',
    boxShadow: '0 0 1px 0 rgba(0,0,0, .08), 0 1px 5px 0 rgba(0,0,0, .05)'
  },
  '& img': {
    maxWidth: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: theme.spacing(2)
  },
  '&:hover::after': {
    background: theme.colors.white,
    boxShadow: theme.shadows[3]
  }
}))

const useStyles = makeStyles(() => ({
  appleIcon: {
    height: 24,
    marginTop: -5,
    display: 'inline-flex',
    '& img': {
      height: 'auto !important'
    }
  }
}))

function BlueBorderBox(props) {
  const template = '{apple-icon}'
  const index = props.title.indexOf(template)
  const classes = useStyles(props)
  let title = (
    <Typography variant="h3" component="h3" gutterBottom>
      {props.title}
    </Typography>
  )

  if (index !== -1) {
    title = (
      <Typography variant="h3" component="h3" gutterBottom>
        {props.title.substring(0, index)}
        <Svg
          height="24"
          width="24"
          src={AppleIcon}
          className={classes.appleIcon}
          alt="Apple Icon"
        />
        {props.title.substring(index + template.length)}
      </Typography>
    )
  }
  return (
    <BoxWrap>
      {placeImage(props.icon, { loading: 'lazy' })}
      {title}
      <Typography
        variant="body1"
        color="textSecondary"
        component="div"
        dangerouslySetInnerHTML={{ __html: props.content }}
      />
    </BoxWrap>
  )
}

export default BlueBorderBox

BlueBorderBox.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  image: PropTypes.string,
  imageAlt: PropTypes.string
}
